import { Badge } from '@classgo/ui';
import { useNavigate, useSearch } from '@tanstack/react-router';

import { EntityList } from '../../components/entity-list';
import { SedeForm } from '../../forms/sede-form';
import { useT } from '../../i18n';

/**
 * The school's sedes. Creating one refreshes the session so the selector shows it. Arriving with
 * `?nueva=true` (the selector's "Agregar otra sede") opens the create form right away.
 */
export const SedesScreen = () => {
  const t = useT();
  const navigate = useNavigate();
  const { nueva } = useSearch({ strict: false }) as { nueva?: boolean };
  return (
    <EntityList
      entity="sedes"
      title={t('sedes.title')}
      caption={t('sedes.caption')}
      createLabel={t('sedes.new')}
      editTitle={t('sedes.edit')}
      emptyTitle={t('sedes.empty.title')}
      emptyBody={t('sedes.empty.body')}
      alsoInvalidate={[['me']]}
      initiallyCreating={nueva === true}
      onCreateClosed={() => void navigate({ to: '/sedes', search: {}, replace: true })}
      canDelete={(row) => !row.isMain}
      columns={[
        {
          key: 'name',
          header: t('sedes.column.name'),
          cell: (row) => (
            <span className="flex items-center gap-2 font-medium text-gray-900">
              {row.name}
              {row.isMain ? <Badge tone="brand">{t('sedes.main')}</Badge> : null}
            </span>
          ),
        },
        {
          key: 'address',
          header: t('sedes.column.address'),
          cell: (row) => row.address ?? t('common.none'),
        },
        {
          key: 'dane',
          header: t('sedes.column.dane'),
          cell: (row) => row.daneSedeCode ?? t('common.none'),
        },
      ]}
      renderForm={({ current, onDone }) => <SedeForm current={current} onDone={onDone} />}
    />
  );
};
